import { Box, Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { PopupDto, PopupService } from "../../api/psc";
import { DialogContainer, DialogHeader } from "../../components/exports";
import { DialogContext } from "../../contexts/DialogueContext";

export default function Popup(props: { popup: PopupDto; preview: boolean }) {
    const { closeDialog } = useContext(DialogContext);

    useEffect(() => {
        if (!props.preview) {
            PopupService.markAsVisited(props.popup.id, "1").finally(() => {});
        }
    }, []);

    const closeOrGoToLink = () => {
        try {
            if (props.popup.actionUrl) {
                window.open(props.popup.actionUrl, "_blank");
            }
        } finally {
            closeDialog();
        }
    };

    return (
        <DialogContainer preferredWith={400}>
            <DialogHeader title="اعلان جدید" />

            <Stack spacing={2} sx={{ p: 2, height: "100%" }}>
                {props.popup.imageId && <img src={props.popup.imageId} />}

                <Typography fontSize="large" color="primary">
                    {props.popup.title}
                </Typography>

                <Typography
                    color="text.secondary"
                    sx={{ whiteSpace: "pre-wrap" }}
                >
                    {props.popup.description}
                </Typography>

                <Box sx={{ flexGrow: 1 }} />

                <Box>
                    <Button variant="contained" onClick={closeOrGoToLink}>
                        {props.popup.actionTitle ?? "بازگشت"}
                    </Button>
                </Box>
            </Stack>
        </DialogContainer>
    );
}
